import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import BannerCarouselBlockData from 'app/Models/Content/BannerCarouselBlockData';
import BannerCarouselMain from './BannerCarouselMain';

export default class BannerCarouselBlock extends EpiComponent<BannerCarouselBlockData> {

    public render(): ReactNode | ReactNodeArray | null {
        return (
         <BannerCarouselMain iContent={this.props.data} context={this.getContext()} />
        );
    }
}
